import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    settingsFormSection: {
        marginBottom: 25,
        '&:last-child': {
            marginBottom: 0
        },
        '& .MuiFormControl-root:nth-child(2)': {
            '& .MuiChip-root': {
                '& .MuiChip-icon': {
                    height: '18px',
                    width: '18px',
                }
            }
        },
        '& .MuiChip-deleteIcon': {
            height: '18px',
            width: '18px'
        },
        '& .MuiAutocomplete-clearIndicator': {
            '& .MuiSvgIcon-root': {
                height: '18px',
                width: '18px'
            }
        }
    },
    formSectionContent: {
        marginTop: 20
    },
    formSectionHeader: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down('md')]: {
            alignItems: 'flex-start',
            flexDirection: 'column'
        }
    },
    formSectionHeading: {
        fontWeight: 500
    },
    manualInput: {
        width: '100%',
        marginBottom: 25,
        '&:last-child': {
            marginBottom: 0
        }
    },
    emailPreferenceCheckboxSection: {
        '& .MuiSvgIcon-root': {
            padding: 0,
            marginRight: 0
        },
        '& .MuiFormControlLabel-root': {
            margin: '0 0 10px 0',
            padding: '0 20px 0 0',
            alignItems: 'flex-start',
            '& .MuiFormControlLabel-root': {
                margin: '0 10px 0 0',
                padding: 0
            },
            '& .MuiCheckbox-root': {
                padding: 0
            }
        },
    }
});